// extracted by mini-css-extract-plugin
export default {"charts":"style_charts__fQEJI","chart2":"style_chart2__R0kO4","card":"style_card__2t4BZ"};